<script>
    // -- IMPORTS
    
    import { languageArrayStore } from "$src/lib/store/languageArrayStore";
    import { onMount } from "svelte";
    import FileInput from "../element/FileInput/FileInput.svelte";
    import InputLocalizedForm from "../element/InputLocalizedForm.svelte";
    import Input from "../element/Input.svelte";
    import { addFileArrayOnObject } from '../../base';

    // -- VARIABLES

    let 
    {     
        blockData = $bindable(
            {
                id : '',
                slug : 'new',
                typeSlug : 'text-and-media',
                sectionPositionNumber: 0,
                number : 0,
                title : null,
                text : null,
                textArray: [],
                mediaPath : null,
                mediaPathArray : [],
                imageFit : null,
                imageHorizontalPosition : null,
                imageVerticalPosition : null,
                imageSide: 'right',
            }
        ),
        number = 0
    } = $props();
    
    let fileArray = $state([]);
    let folderPath = 'block/'
                      + blockData?.slug?.toLowerCase().replaceAll("-", "_")
                      + '/';

    // -- FUNCTIONS

    function handleUpdateLocalizedInput(
        event
        )
    {
        blockData[ event.detail.name ] = event.detail.text;
    }

    // ~~

    function setDefaultFileArray(
        )
    {
        if ( blockData?.mediaPath !== null 
             && blockData?.mediaPath !== '' )
        {
            fileArray = [ blockData.mediaPath ];
        }
        else
        {
            fileArray = blockData.mediaPathArray ?? [];
        }
    }

    // -- STATEMENTS

    onMount( 
        () =>
        {
            setDefaultFileArray();
            blockData.number = number;
        }
    );

    $effect(
        () =>
        {
            addFileArrayOnObject( blockData, fileArray )
        }
    );
</script>

<div class="block-section">
    <Input
        label={ 'Position in section' }
        id="number"
        type="number"
        helperText="This number is used to sort inside the section"
        fullWidth
        bind:value={ blockData.sectionPositionNumber }
    />

    <InputLocalizedForm
        itemsString={ blockData.title }
        languageArray={ $languageArrayStore }
        name={ 'title' }
        onUpdate={ handleUpdateLocalizedInput }
        placeholder={ 'title' }
    />
    
    <InputLocalizedForm
        isMultiLine
        itemsString={ blockData.text }
        languageArray={ $languageArrayStore }
        name={ 'text' }
        onUpdate={ handleUpdateLocalizedInput }
        placeholder={ 'text' }
    />
    
    <InputLocalizedForm
        itemsString={ blockData.teaser }
        languageArray={ $languageArrayStore }
        name={ 'teaser' }
        onUpdate={ handleUpdateLocalizedInput }
        placeholder={ 'Call to action' }
    />

    <InputLocalizedForm
        itemsString={ blockData.href }
        languageArray={ $languageArrayStore }
        name={ 'href' }
        onUpdate={ handleUpdateLocalizedInput }
        placeholder={ 'Destination' }
    />
</div>

<div class="block-section">
    <h2>Media</h2>
    <FileInput
        bind:fileArray={ fileArray }
        fileInputName="image-path"
        acceptedType="image/*, video/*"
        maxFileCount={ 2 }
        filePath={ folderPath }
    />
</div>